/**
 * Matriz de permisos (§6 del plan). En el MVP se verifica en la fachada; en Medellín Joven
 * se replica en el backend con `VERIFICAR_ROL`.
 */
import { AsistenciaRol } from './asistencia.model';

export type Capacidad =
  | 'CONFIGURAR_CICLO'
  | 'IMPORTAR'
  | 'ASIGNAR_MENTORES'
  | 'GESTIONAR_SESIONES'
  | 'EDITAR_PARTICIPANTE'
  | 'PROPONER_CONTACTO'
  | 'VERIFICAR_CUENTA_MJ'
  | 'TOMAR_ASISTENCIA'
  | 'EXTRA_GRUPO'
  | 'CORREGIR_ASISTENCIA'
  | 'SOLICITAR_CORRECCION'
  | 'REGISTRAR_EXCUSA'
  | 'APROBAR_EXCUSA'
  | 'REGISTRAR_SEGUIMIENTO'
  | 'VER_SEGUIMIENTO'
  | 'GESTIONAR_INSCRIPCIONES'
  | 'RESOLVER_SOLICITUDES'
  | 'VER_PROGRESO'
  | 'VER_PROGRESO_GLOBAL'
  | 'VER_HISTORICO'
  | 'VER_TRAZABILIDAD_GLOBAL'
  | 'VER_CORREOS'
  | 'REINTENTAR_CORREOS'
  | 'EXPORTAR'
  | 'GESTIONAR_ALERTAS_PROPIAS'
  | 'ADMINISTRAR_CATALOGO_ALERTAS'
  | 'VER_DOCUMENTO_COMPLETO';

const MATRIZ: Record<AsistenciaRol, ReadonlySet<Capacidad>> = {
  COORDINADOR_MML: new Set<Capacidad>([
    'CONFIGURAR_CICLO', 'IMPORTAR', 'ASIGNAR_MENTORES', 'GESTIONAR_SESIONES', 'EDITAR_PARTICIPANTE',
    'VERIFICAR_CUENTA_MJ', 'TOMAR_ASISTENCIA', 'EXTRA_GRUPO', 'CORREGIR_ASISTENCIA', 'REGISTRAR_EXCUSA',
    'APROBAR_EXCUSA', 'REGISTRAR_SEGUIMIENTO', 'VER_SEGUIMIENTO', 'GESTIONAR_INSCRIPCIONES',
    'RESOLVER_SOLICITUDES', 'VER_PROGRESO', 'VER_PROGRESO_GLOBAL', 'VER_HISTORICO',
    'VER_TRAZABILIDAD_GLOBAL', 'VER_CORREOS', 'REINTENTAR_CORREOS', 'EXPORTAR',
    'GESTIONAR_ALERTAS_PROPIAS', 'ADMINISTRAR_CATALOGO_ALERTAS', 'VER_DOCUMENTO_COMPLETO'
  ]),
  MENTOR_MML: new Set<Capacidad>([
    'PROPONER_CONTACTO', 'TOMAR_ASISTENCIA', 'EXTRA_GRUPO', 'SOLICITAR_CORRECCION', 'REGISTRAR_EXCUSA',
    'REGISTRAR_SEGUIMIENTO', 'VER_SEGUIMIENTO', 'VER_PROGRESO', 'VER_HISTORICO', 'EXPORTAR',
    'GESTIONAR_ALERTAS_PROPIAS'
  ]),
  ESTUDIANTE_MML: new Set<Capacidad>(['GESTIONAR_ALERTAS_PROPIAS'])
};

export function tieneCapacidad(rol: AsistenciaRol | 'SISTEMA', capacidad: Capacidad): boolean {
  if (rol === 'SISTEMA') return true;
  return MATRIZ[rol].has(capacidad);
}

export function capacidadesDe(rol: AsistenciaRol): Capacidad[] {
  return [...MATRIZ[rol]];
}
